import { useOrgFeatureFlags, type OrgFeatureFlagKey } from '../../hooks/useOrgFeatureFlags';
import { resolvePlanSurface, type PlanSurfaceInput, type PlanSurfaceResult } from './planSurface';
import { usePlanRequirements } from './usePlanRequirements';

export interface PlanSurfaceState extends PlanSurfaceResult {
  /**
   * Do not run the feature. False while the flags themselves are still
   * loading, so a flag-off page keeps the request it already makes today.
   * True once the preview is on and the plan is not yet known, or is known
   * to lack the feature.
   */
  hold: boolean;
}

export function usePlanSurface(input: PlanSurfaceInput): PlanSurfaceState {
  const flags = useOrgFeatureFlags();
  const plan = usePlanRequirements();
  const orgFlag = input.orgFlag as OrgFeatureFlagKey | undefined;
  const resolved = resolvePlanSurface(input, {
    flagsLoading: flags.isLoading === true,
    showLocked: plan.showLocked,
    requirements: plan.requirements,
    requirementsPending: plan.requirementsPending,
    requirementsFailed: plan.requirementsFailed,
    orgFlagEnabled: orgFlag ? flags.isEnabled(orgFlag) === true : false,
    orgFlagSource: orgFlag && flags.sourceOf ? flags.sourceOf(orgFlag) : undefined,
  });
  return {
    ...resolved,
    hold: resolved.mode === 'locked' || (resolved.mode === 'pending' && flags.isLoading !== true),
  };
}
